import {
  SignalProp,
  makeAuthenticatedNetworkRequest,
  unwrapNetworkResponse,
} from '../../../services/api';

export const wetlandsUrlBaseUrl = import.meta.env
  .VITE_PRIVATE_API_GATEWAY_URL as string;
export const wetlandsUrlRelativeUrl = `/wetlands`;

export interface WetlandsFeature {
  type: string;
  id: number;
  geometry: {
    coordinates: [[number, number]][];
  };
  properties: {
    'Wetlands.WETLAND_TYPE': string;
  };
}

export interface GetWetlandsDataResType {
  type?: string;
  features: WetlandsFeature[];
}

export interface GetWetlandsDataReqType {
  latitude: number;
  longitude: number;
}

export const getWetlandsData = async ({
  latitude,
  longitude,
  signal,
}: GetWetlandsDataReqType & SignalProp) => {
  const res = await makeAuthenticatedNetworkRequest({
    method: 'GET',
    baseUrl: wetlandsUrlBaseUrl,
    relativeUrl: `${wetlandsUrlRelativeUrl}?latitude=${latitude}&longitude=${longitude}`,
    signal,
  });

  const data = await unwrapNetworkResponse<GetWetlandsDataResType>(res);
  return data;
};
